'use client'

import { useCallback } from 'react'

import { useConfigsContext } from '@/context/ConfigsContext'
import { useUAContext } from '@/context/UAContext'
import { fetchCheckUserCommunityPermission } from '@/services/community'
import { HubsStore } from '@/types/store'

const useGetCommunityToggle = () => {
  const { isMobileApp } = useUAContext()
  const { appConfig } = useConfigsContext()
  const enableCommunity = appConfig?.features?.enable_community === true
  const enableCommunityMobileApp = appConfig?.features?.enable_community_mobileapp === true

  return useCallback(
    async (credentials: HubsStore['credentials']) => {
      const htcToken = credentials?.htcToken

      if (!enableCommunity) {
        return false
      }

      if (isMobileApp && !enableCommunityMobileApp) {
        return false
      }

      const hasPermission = await fetchCheckUserCommunityPermission(htcToken!)
      const communityToggle = hasPermission ? true : false

      return communityToggle
    },
    [enableCommunity, enableCommunityMobileApp, isMobileApp],
  )
}

export default useGetCommunityToggle
